// extracted by mini-css-extract-plugin
export default {"root":"TwZuKx","suffix":"Now4Xp"};